import React, { Component } from 'react';
import { Media } from 'react-bootstrap';
import TextInput from '../common/TextInput';
import { map, cloneDeep, findIndex, isEqual } from 'lodash';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import Button from '../common/Button';
import PageLoader from '../common/PageLoader';
import EmptyState from '../EmptyState/EmptyState';
import { imageBasePath } from '../../constants/staticData';
import CustomModal from '../common/CustomModal';
import { Modal } from 'react-bootstrap';

class SelectionBox extends Component {
  constructor(props) {
    super(props);
    let check = findIndex(props.serviceData, (service) => {
      return service.status == 0 || service.status == null;
    });
    this.state = {
      isButtonLoading: false,
      clickedTab: '',
      showModal: false,
      SToggleSwitch: check == -1 ? true : false,
      data: props.serviceData
    };
    this.handleCheck = this.handleCheck.bind(this);
    this.priceChanged = this.priceChanged.bind(this);
    this.handleTabSwitch = this.handleTabSwitch.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer.hideButtonLoader && this.state.isButtonLoading) {
      // this.props.actions.hideToastMessage();
      if (((nextProps.serviceType == 'carwash' && !nextProps.vendorProfileReducer.garageServicesError.washError)
        || (nextProps.serviceType == 'emergency' && !nextProps.vendorProfileReducer.garageServicesError.emergencyError)) && nextProps.buttonLabel == 'Next') {
        this.props.btnCallBack();
      }
      this.setState({ 'isButtonLoading': false });
    }
    if (!this.state.data) {
      let check = findIndex(nextProps.serviceData, (service) => {
        return service.status == 0 || service.status == null;
      });
      this.setState({ data: nextProps.serviceData, SToggleSwitch: check == -1 ? true : false });
    }
  }

  handleCheck(categoryIndex, type) {
    let boxData = cloneDeep(this.state.data);
    let index = findIndex(boxData, { id: categoryIndex });
    if (index != -1) {
      boxData[index].status = type.target.checked ? 1 : 0;
    }
    let check = findIndex(boxData, (service) => {
      return service.status == 0 || service.status == null;
    });

    this.setState({ data: boxData, SToggleSwitch: check == -1 ? true : false });
  }

  changeToggle() {
    let boxData = cloneDeep(this.state.data);

    map(boxData, (service, key) => {
      boxData[key].status = !this.state.SToggleSwitch ? 1 : 0;
    });
    this.setState({ data: boxData, SToggleSwitch: !this.state.SToggleSwitch })
  }



  priceChanged(carType, price, categoryIndex) {


    const floatRegExp = new RegExp('^[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');

    if(! floatRegExp.test(price) || price <= 0){
      price = "";
    }

    let copyCarService = cloneDeep(this.state.data);
      let index = findIndex(copyCarService, { id: categoryIndex });
      if (index != -1) {
        if (carType == 'sedan') {
          copyCarService[index].cost_sedan = price;
        } else if (carType == 'suv') {
          copyCarService[index].cost_suvs = price;
        }
      }
      this.setState({ data: copyCarService });
  }

  descpChanged(carType, descp, categoryIndex) {
    let copyCarService = cloneDeep(this.state.data);
    let index = findIndex(copyCarService, { id: categoryIndex });
    if (index != -1) {
        if (carType == 'sedan') {
          copyCarService[index].descp_sedan = descp ? descp : '';
          copyCarService[index].descp_suv = copyCarService[index].descp_suv ? copyCarService[index].descp_suv : '';
        } else if (carType == 'suv') {
          copyCarService[index].descp_suv = descp ? descp : '';
          copyCarService[index].descp_sedan = copyCarService[index].descp_sedan ? copyCarService[index].descp_sedan : '';
        }
    }
    this.setState({ data: copyCarService });
  }

  handleTabSwitch(tabName) {
    if (!isEqual(this.props.serviceData, this.state.data)) {
      this.setState({ showModal: true, clickedTab: tabName });
    } else {
      this.props.tabClickSwitch(tabName);
    }

  }

  render() {
    const { btnCallBack, actions, isLoaded, serviceData, topLevelServiceData, buttonLabel, hide } = this.props;
    return (
      <div className={hide ? 'hide' : ''}>
        {serviceData && serviceData.length ? <span className="toggle-switch toggleBtn s-selection-box">
          <span>Select All</span>
          <ToggleSwitch
            checked={this.state.SToggleSwitch}
            onChange={() => this.changeToggle()}
            size="small"
          />
        </span> : ''}

        <div className="selection-box">
          {isLoaded ? serviceData && serviceData.length ? map(this.state.data, (boxData, key) => {
            return (
              <div key={key} className={boxData.status ? "selection-box-holder active" : "selection-box-holder"}>
                <div className="checkbox checkbox-style">
                  <input type="checkbox" id={key}
                    checked={boxData.status} onChange={(checked) => { this.handleCheck(boxData.id, checked); }} />
                  <label htmlFor={key} className="custom-checkbox" />
                </div>
                <div className="s-media">
                  <div className="s-media-content">
                    <Media>
                      <Media.Left>
                        <img className="s-media-image" src={boxData.parentImage ? boxData.parentImage : `${imageBasePath}/placeholder.png`} alt="Image" />
                      </Media.Left>
                      <Media.Body>
                        <Media.Heading>{boxData.serviceTitle}</Media.Heading>
                        <p>{boxData.serviceDescription}</p>
                      </Media.Body>
                    </Media>
                  </div>
                </div>
                <div className="s-prices">
                  <div className="sedan-section">
                      <p className="car-type">Sedan</p>
                      <div className="holder price-holder">
                        <span className="currency">AED</span>
                        <TextInput type="numeric"
                          customClass={boxData.cost_sedan ? "focus" : ""}
                          label="Price"
                          name="name"
                          value={boxData.cost_sedan}
                          min="0"
                          onChange={(text) => { this.priceChanged('sedan', text, boxData.id); }}
                        />
                      </div>
                      <div className="holder descp-holder">
                        <TextInput type="text"
                          customClass={boxData.descp_sedan ? "focus" : ""}
                          label="Add Description"
                          name="name"
                          value={boxData.descp_sedan ? boxData.descp_sedan : ''}
                          onChange={(text) => { this.descpChanged('sedan', text, boxData.id); }}
                        />
                      </div>
                      {(boxData.descp_sedan.length > 200) ? <p className="box-descp-err">Should be less than 200 characrers</p> : ''}
                  </div>
                  <div className="suv-section">
                    <p className="car-type">SUV</p>
                    <div className="holder price-holder">
                      <span className="currency">AED</span>
                      <TextInput type="tel"
                        customClass={boxData.cost_suvs ? "focus" : ""}
                        label="Price"
                        name="name"
                        value={boxData.cost_suvs}
                        min="0"
                        onChange={(text) => { this.priceChanged('suv', text, boxData.id); }}
                      />
                    </div>
                    <div className="holder descp-holder">
                      <TextInput type="text"
                        customClass={boxData.descp_suv ? "focus" : ""}
                        label="Add Description"
                        name="name"
                        value={boxData.descp_suv ? boxData.descp_suv : ''}
                        onChange={(text) => { this.descpChanged('suv', text, boxData.id); }}
                      />
                    </div>
                    {(boxData.descp_suv.length > 200) ? <p className="box-descp-err">Should be less than 200 characrers</p> : ''}
                  </div>
                </div>
              </div>
            );
          })
            : <EmptyState image={`${imageBasePath}/empty_service.png`} message={'This Service is Currently unavailable'} /> : <PageLoader />}
        </div>
        {serviceData && serviceData.length ? <span className="ms-button">
          <Button btnType="red" btnSize="sm" fontSize={15} label={buttonLabel} btnCallBack={() => {
            actions.addGarageServices(this.state.data, serviceData, this.props.isEmergencyServices, [], topLevelServiceData);
            this.setState({ isButtonLoading: true });
          }} isButtonLoading={this.state.isButtonLoading} />
        </span> : ''}
        <CustomModal className="decline-modal" showModal={this.state.showModal} footer="true" title="Save Changes" hideModal={() => this.setState({ showModal: false })} saveText="Save" submitCallBack={() => {
          actions.addGarageServices(this.state.data, serviceData, this.props.isEmergencyServices, [], topLevelServiceData);
          this.setState({ showModal: false });
          this.props.tabClickSwitch(this.state.clickedTab);
        }}>
          <Modal.Body>
            <div>
              <span className="caption-result">Do you want to save the changes you just made?</span>
            </div>
          </Modal.Body>
        </CustomModal>
      </div>
    );
  }
}

export default SelectionBox;



// WEBPACK FOOTER //
// ./src/components/ManageServices/SelectionBox.jsx